module.exports = __webpack_public_path__ + "fonts/Graphik-Semibold.699915f5.ttf";